<div class="company-card card border-0 shadow-sm hover-card h-100 mobile">

    <!-- Image principale -->
    <div class="image-container position-relative">
        @if(company.gallery && company.gallery.length > 0) {
            <img [src]="company.gallery[0].startsWith('/') ? apiUrl + company.gallery[0] : company.gallery[0]"
                 class="main-image w-100" alt="Logo">
        } @else {
            <img src="/images/logo/Referio.png" class="main-image w-100" alt="Logo">
        }

        <!-- Favoris -->
        <button class="btn favorite-btn position-absolute top-0 end-0 m-2 rounded-circle"
                (click)="toggleFavorite(company)">
            @if (user?.favorites?.includes(company._id)) {
                <i class="bi bi-heart-fill text-danger"></i>
            } @else {
                <i class="bi bi-heart"></i>
            }
        </button>
    </div>

    <!-- Miniatures -->
    @if(company.gallery && company.gallery.length > 1) {
        <div class="thumbnails-row">
            @for(img of company.gallery.slice(1, 4); track $index) {
                <div class="thumb-item">
                    <img [src]="img.startsWith('/') ? apiUrl + img : img" alt="thumb">
                </div>
            }
        </div>
    }

    <!-- Contenu -->
    <div class="card-body px-3 py-2">

        <!-- Titre + badge -->
        <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
            <h6 class="card-title mb-0 fw-bold">{{ company.companyName }}</h6>
            <span class="badge category-badge">{{ company.category }}</span>
        </div>

        <!-- Stars + vues -->
        <div class="d-flex align-items-center gap-2 mb-2">
            <div class="text-warning stars">
                @for(star of starsArray; track $index){
                    @if(star === 'full') { <i class="bi bi-star-fill"></i> }
                    @else if(star === 'half') { <i class="bi bi-star-half"></i> }
                    @else { <i class="bi bi-star"></i> }
                }
            </div>
            <small class="text-muted">({{ company.ratings ? company.ratings.length : 0 }})</small>
            <span class="text-muted views-count">
                <i class="bi bi-eye me-1"></i>{{ company.totalViews }}
            </span>
        </div>

        <!-- Footer : réseaux + bouton -->
        <div class="d-flex align-items-center justify-content-between gap-2">
            <div class="d-flex gap-1">
                @if(company.socialMediaLinks?.facebook){
                    <a [href]="company.socialMediaLinks.facebook" target="_blank" class="social-icon">
                        <i class="bi bi-facebook" style="color: #1877f2;"></i>
                    </a>
                }
                @if(company.socialMediaLinks?.instagram){
                    <a [href]="company.socialMediaLinks.instagram" target="_blank" class="social-icon">
                        <i class="bi bi-instagram" style="color: #e4405f;"></i>
                    </a>
                }
                @if(company.socialMediaLinks?.linkedin){
                    <a [href]="company.socialMediaLinks.linkedin" target="_blank" class="social-icon">
                        <i class="bi bi-linkedin" style="color: #0a66c2;"></i>
                    </a>
                }
            </div>
            <a [routerLink]="'/company/' + company._id" class="btn btn-primary btn-sm cta-btn">
                Voir <i class="bi bi-arrow-right ms-1"></i>
            </a>
        </div>

    </div>
</div>